module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.6c980940.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/Rubik-Regular/Rubik-Regular.ttf
// module id = 1295
// module chunks = 49